import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import useMediaQuery from "../../hooks/useMediaQuery";
import eventBus from "../../utils/eventBus";

interface CreateEffectModalProps {
  onClose: () => void;
}

const CreateEffectModal: React.FC<CreateEffectModalProps> = ({ onClose }) => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width: 768px)");

  useEffect(() => {
    if (isMobile) {
      eventBus.emit("fullscreen:enter");
    }
    return () => {
      if (isMobile) {
        eventBus.emit("fullscreen:exit");
      }
    };
  }, [isMobile]);

  const handleNavigate = () => {
    if (isMobile) {
      eventBus.emit("fullscreen:exit");
    }
    navigate("/create", { state: { activeSection: "effects" } });
    onClose();
  };

  const handleClose = () => {
    if (isMobile) {
      eventBus.emit("fullscreen:exit");
    }
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <motion.div
        initial={isMobile ? { y: "100%" } : { y: "-100%" }}
        animate={{ y: 0 }}
        exit={isMobile ? { y: "100%" } : { y: "-100%" }}
        transition={{ type: "spring", stiffness: 300, damping: 30 }}
        className={`bg-gray-800 text-white p-6 w-full max-w-md mx-auto ${
          isMobile
            ? "rounded-t-2xl absolute bottom-0"
            : "rounded-2xl relative"
        }`}
      >
        <div className="flex items-center mb-4">
          <div className="bg-gray-700 p-2 rounded-full mr-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 text-purple-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l-3 3m5 5l3 3M18 6l-3 3m-5 5l-3 3m5 5l3 3m-3-5l3-3m-5 5l-3-3"
              />
            </svg>
          </div>
          <div>
            <h2 className="text-xl font-bold">
              Create & Share Your Own Effects!
            </h2>
            <p className="text-gray-400">
              Unleash your creativity and build unique photo and video effects
              for the community.
            </p>
          </div>
        </div>
        <button
          onClick={handleNavigate}
          className="w-full bg-purple-600 hover:bg-purple-700 text-white font-bold py-3 rounded-lg transition-colors"
        >
          Start Creating
        </button>
        <button
          onClick={handleClose}
          className="w-full mt-2 text-gray-400 hover:text-white"
        >
          Maybe Later
        </button>
      </motion.div>
    </div>
  );
};

export default CreateEffectModal;
